import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApLogo135X18 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 135,
	height: 18,
	viewBox: "0 0 135 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M124.818 17.2485C119.175 17.2485 115.455 13.5269 115.455 8.59881C115.455 3.67068 119.175 0 124.818 0C130.462 0 134.181 3.72151 134.181 8.6007C134.181 13.4799 130.435 17.2503 124.818 17.2503V17.2485ZM124.818 14.0954C128.564 14.0954 130.733 11.8045 130.733 8.6007C130.733 5.39685 128.564 3.15491 124.818 3.15491C121.072 3.15491 118.879 5.44579 118.879 8.6007C118.879 11.7556 121.048 14.0954 124.818 14.0954Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.5527 17.0188V0.361421H92.2377C95.466 0.361421 97.6345 2.30783 97.6345 5.24061C97.6345 8.17339 95.466 10.0953 92.2377 10.0953H85.9053V17.0188H82.5527ZM85.9034 3.46739V6.99124H92.1868C93.5177 6.99124 94.1822 6.32675 94.1822 5.21614C94.1822 4.10552 93.5177 3.46739 92.1868 3.46739H85.9034Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.154 17.0188H56.824V0.359539H60.154V7.0063H69.5566V0.359539H72.911V17.0188H69.5566V10.1104H60.154V17.0188Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8718 17.2485C41.2283 17.2485 37.6311 13.5269 37.6311 8.59881C37.6311 3.67068 41.2302 0 46.7249 0C50.422 0 53.1326 1.47769 54.6103 3.94363L51.9731 5.79215C50.8154 4.06787 49.189 3.15491 46.7249 3.15491C43.1277 3.15491 41.057 5.44579 41.057 8.6007C41.057 11.7556 43.1277 14.0954 46.8718 14.0954C49.3848 14.0954 51.3067 12.9867 52.3176 11.4092L54.8061 13.158C53.3021 15.6221 50.4446 17.2485 46.8718 17.2485Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.757 0.363304L7.45615 0.359539L0.726562 17.0188H4.34266L5.58316 13.9448H14.6337L15.8743 17.0188H19.4885L12.757 0.363304ZM6.83119 10.8558L9.72068 3.71398H10.4981L13.3857 10.8558H6.83119Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.0452 0.359539H79.4147V17.0188H76.0452V0.359539Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.7481 9.85626C34.9223 9.25766 36.287 7.56726 36.287 5.24061C36.287 2.30783 34.1185 0.361421 30.8902 0.361421H21.2052V17.0188H24.5578V10.0953H29.0153L33.0116 17.0188H36.8819L32.7481 9.85626ZM24.5559 6.99124V3.46739H30.8394C32.1702 3.46739 32.8347 4.10552 32.8347 5.21614C32.8347 6.32675 32.1702 6.99124 30.8394 6.99124H24.5559Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.727 9.85626C112.901 9.25766 114.266 7.56726 114.266 5.24061C114.266 2.30783 112.097 0.361421 108.869 0.361421H99.1837V17.0188H102.536V10.0953H106.994L110.99 17.0188H114.86L110.727 9.85626ZM102.534 6.99124V3.46739H108.818C110.149 3.46739 110.813 4.10552 110.813 5.21614C110.813 6.32675 110.149 6.99124 108.818 6.99124H102.534Z",
			fill: "#929292"
		})
	]
});
const ForwardRef = forwardRef(SvgApLogo135X18);
export { ForwardRef as ReactComponent };
